import React from 'react';
import { Button } from 'react-admin';
import { l } from '../IdentityShow';
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import { useTranslate } from 'react-admin';

interface Props {
  onClick?: () => void;
  [x: string]: any;
}

const Force2FAButton = (props: Props) => {
  const { onClick, ...rest } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <Button label={t('force2FA')} onClick={onClick} {...rest}>
      <EnhancedEncryptionIcon />
    </Button>
  );
};

export default Force2FAButton;
